var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { useFormContext } from "react-hook-form";
import { useDebouncedValidation } from "../../utility/useDebouncedValidation";
import { RadixInput } from "../../primitives/RadixInput";
export var ZipCodeField = function (props) {
    var _a = useFormContext(), register = _a.register, errors = _a.formState.errors, trigger = _a.trigger;
    var debouncedTrigger = useDebouncedValidation(trigger);
    var _b = register("zipCode"), ref = _b.ref, onBlur = _b.onBlur, onChange = _b.onChange, name = _b.name;
    return (React.createElement("div", { className: "radix-form-field" },
        React.createElement(RadixInput, __assign({ id: "avsZipCode", name: name, ref: ref, onBlur: onBlur, onChange: function (event) {
                onChange(event);
                debouncedTrigger("zipCode");
            }, placeholder: "Zip Code *", "aria-invalid": !!errors.zipCode, "aria-describedby": errors.zipCode ? "avsZipCode-error" : undefined, "aria-label": "Zip Code", inputMode: "numeric", autoComplete: "billing postal-code", type: "tel" }, props)),
        errors.zipCode && (React.createElement("span", { id: "avsZipCode-error", className: "radix-error-message" },
            React.createElement("i", { className: "fas fa-exclamation-circle" }),
            " ",
            errors.zipCode.message))));
};
